import globals from './Globals';
import loader from './Loader';
import RenderContainer from './RenderContainer';

class PlayButton extends RenderContainer {
  constructor() {
    super();
    this.name = 'PlayButton';
    this.imageName = 'play';
    this.bitmap = null;
    loader.addItem(this, this.imageName);
    this.relX = 0.25;
    this.relY = 0.3;
    const pos = globals.relToScreen({ x: this.relX, y: this.relY });
    this.x = pos.x;
    this.y = pos.y;
    this.maxWidth = 0.3;
    this.maxHeight = 0.3;
    const size = globals.relSizeToScreen({
      x: this.maxWidth,
      y: this.maxHeight
    });
    this.render.stream = false;
    this.width = size.x;
    this.height = size.y;
    this.setBounds(this.x, this.y, this.width, this.height);
    this.on('click', this.press, this);
  }

  press() {
    this.dispatchEvent('PlayStart', true);
  }

  loaded() {
    const image = loader.getItem(this.imageName);
    this.clipImageSizeToSize(image);
    this.centerOnSelf();

    this.bitmap = new createjs.Bitmap(image);
    this.addChild(this.bitmap);
    this.render.once = true;
    this.render.stream = false;
  }
}

export { PlayButton as default };
